import React from 'react';
import { Link, Typography } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { PageLink } from '@/data/Navigation';
import { LinkWrap } from '@/components/blocks/Linkable';
import {
	headerMobileBreadcrumbMenuItemLinkSX,
	headerMobileBreadcrumbMenuIconSX,
	headerMobileBreadcrumbTypographyMainSX,
} from '@/components/content/Header/styles/mobileDrawer';

export const BreadcrumbLink = ({
	label,
	onClick,
	url,
}: {
	label: string;
	onClick: () => void;
	url?: string;
}) => (
	<Link href={url} color="inherit" onClick={onClick}>
		<Typography variant="h6" sx={headerMobileBreadcrumbTypographyMainSX}>
			{label}
		</Typography>
	</Link>
);

export const BreadcrumbMenuItemLinkWrap = ({ url, label }: { url?: string; label: string }) => (
	<LinkWrap href={url}>
		<Link
			sx={{
				...headerMobileBreadcrumbMenuItemLinkSX,
				color: label === 'Ver todo' ? '#011688' : '#2c2c2c',
			}}
		>
			<Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '15px' }}>
				{label}
			</Typography>
		</Link>
	</LinkWrap>
);

export const BreadcrumbMenuItemLinkExpand = ({
	label,
	level,
	onClick,
}: {
	label: string;
	level: number;
	onClick: () => void;
}) => (
	<Link
		sx={{
			...headerMobileBreadcrumbMenuItemLinkSX,
			fontWeight: level === 0 ? '900' : 'bold',
			fontSize: level === 0 ? '18px' : '16px',
		}}
		textTransform={level === 0 ? 'uppercase' : undefined}
		onClick={onClick}
	>
		{label}

		<ArrowForwardIosIcon sx={headerMobileBreadcrumbMenuIconSX} />
	</Link>
);

export const BreadcrumbMenuItem = ({
	label,
	url,
	childrenPageLink,
	level,
	onClick,
}: {
	label: string;
	url?: string | undefined;
	childrenPageLink: PageLink[];
	level: number;
	onClick: () => void;
}) => {
	if (childrenPageLink.length > 0) {
		return <BreadcrumbMenuItemLinkExpand label={label} level={level} onClick={onClick} />;
	}

	return <BreadcrumbMenuItemLinkWrap url={url} label={label} />;
};
